<div class="tabContent tabContent--noPadding">
  @if (processing) {
    <pp-account-settings-sites-placeholder />
  }

  @if (!processing) {
    <cdk-virtual-scroll-viewport
      itemSize="40"
      minBufferPx="900"
      maxBufferPx="1350"
      class="accountList__scroll"
    >
      <table class="settingsTable settingsTable--wide" aria-label="Account sites table">
        <thead class="settingsTable__head" [style.top]="inverseOfTranslation">
          <tr>
            <th
              class="settingsTable__header secondaryBody--semibold settingsTable__column--sites settingsTable__column--siteName"
              scope="col"
            >
              {{ 'site_name' | ppTranslate }}
              @if (canSeeArchived) {
                <span class="siteListCounter">
                  {{
                    'account_settings_sites_header'
                      | ppTranslate
                        : {
                            all: showArchivedData
                              ? unfilteredSites.length
                              : unfilteredSites.length + archivedSitesCount,
                            archived: archivedSitesCount,
                          }
                  }}
                </span>
              }
              @if (!canSeeArchived) {
                <span class="siteListCounter">({{ unfilteredSites.length }})</span>
              }
            </th>
            <th
              class="settingsTable__header secondaryBody--semibold settingsTable__column--sites"
              scope="col"
            >
              {{ 'number_of_users' | ppTranslate }}
            </th>
            <th
              class="settingsTable__header secondaryBody--semibold settingsTable__column--sites"
              scope="col"
            >
              {{ 'total_points' | ppTranslate }}
            </th>
            <th
              class="settingsTable__header secondaryBody--semibold settingsTable__column--sites"
              scope="col"
            >
              {{ 'used_storage' | ppTranslate }}
            </th>
          </tr>
        </thead>
        <tbody class="settingsTable__body">
          <ng-container *cdkVirtualFor="let site of visibleSites; let index = index">
            <pp-account-settings-site
              class="settingsTable_site"
              [ppSite]="site"
              (ppNavigate)="navigateToSite($event)"
              [ppCanSeeArchived]="canSeeArchived"
            ></pp-account-settings-site>
          </ng-container>
        </tbody>
      </table>
    </cdk-virtual-scroll-viewport>
    @if (!processing) {
      <pp-account-settings-site-footer
        [ppNumberOfVisibleSites]="visibleSites.length"
      ></pp-account-settings-site-footer>
    }
    @if (processing) {
      <div class="accountUsers__spinner">
        <pp-spinner></pp-spinner>
      </div>
    }
  }
</div>

<pp-account-settings-sites-bulk-changes
  [ppAccountId]="accountId"
  [ppUnarchivedSitesCount]="unarchivedSitesCount"
  (ppUpdate)="refreshSiteData()"
></pp-account-settings-sites-bulk-changes>
